import { useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { AuthResult } from "../../enums/authResult";

const TOKEN_REFRESH_INTERVAL = 1_800_000; // 30 minutes in milliseconds

const TokenRefresh = () => {
  const { instance, accounts } = useMsal();

  const refreshToken = async () => {
    console.log("Attempting to refresh token...");
    await instance.initialize();
    await instance
      .acquireTokenSilent({
        scopes: ["User.Read"],
        account: accounts[0],
        forceRefresh: true,
      })
      .then((tokenResponse) => {
        localStorage.setItem(AuthResult.IdToken, tokenResponse.idToken);
      })
      .catch((error) => {
        console.error("Token refresh failed:", error);
      });
  };

  useEffect(() => {
    let intervalId: any;
    if (instance && accounts.length > 0) {
      refreshToken();
      intervalId = setInterval(refreshToken, TOKEN_REFRESH_INTERVAL);
    }

    return () => clearInterval(intervalId);
  }, [instance, accounts]);

  return <></>;
};

export default TokenRefresh;
